export enum AccessTypeFilter {
  ACCESS_VALID = 'ACCESS_VALID',
  ACCESS_DENIED = 'ACCESS_DENIED',
  ALL = 'ALL'
}
